// extracted by mini-css-extract-plugin
export var bounce = "_ni-1";
export var generatingText = "_ni-6";
export var lightning = "_ni-4";
export var popup = "_ni-5";
export var progressBar = "_ni-7";
export var progressFill = "_ni-8";
export var progressShimmer = "_ni-9";
export var progressText = "_ni-a";
export var shimmer = "_ni-3";
export var uploadIcon = "_ni-0";
export var uploadingText = "_ni-2";